module.exports = __webpack_public_path__ + "media/assets/images/blog/customer_service_incertezza-ed76d2ff71b24efa12c3a7c9373ec9f4.png";